import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'

// Banff Airporter brand colors
const banffAirporterTheme = {
  dark: false,
  colors: {
    background: '#f8f4ed',
    surface: '#ffffff',
    primary: '#f8b31b', // Banff Airporter yellow
    secondary: '#5b6ee5', // Banff Airporter blue
    success: '#2cb543', // Banff Airporter green
    error: '#d32f2f',
    warning: '#f8b31b',
    info: '#5b6ee5',
    'on-background': '#1c1c1e',
    'on-surface': '#1c1c1e',
    'on-primary': '#000000',
    'on-secondary': '#ffffff',
  },
}

// Components and directives are auto-imported by vite-plugin-vuetify
// Styles are injected per-component with SASS variable overrides from src/styles/settings.scss
export default createVuetify({
  theme: {
    defaultTheme: 'banffAirporter',
    themes: {
      banffAirporter: banffAirporterTheme,
    },
  },
  defaults: {
    VCard: {
      elevation: 0,
      rounded: 0,
    },
    VBtn: {
      rounded: 'pill',
    },
  },
})
